module.exports = __webpack_public_path__ + "img/9-17.e0642678.jpg";